const INTERNAL_FLOW_PATTERN = /^flowbuilder:\/\/flows\/[1-9]\d*$/;

export const isDataSourceReference = value => {
  if (INTERNAL_FLOW_PATTERN.test(String(value || ''))) return true;

  try {
    const url = new URL(value);
    return (
      ['http:', 'https:'].includes(url.protocol) &&
      !url.username &&
      !url.password
    );
  } catch {
    return false;
  }
};

export const flowReference = flowId => `flowbuilder://flows/${flowId}`;
